/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { CreateGiftQuoteResponse, CreateGiftQuoteVars } from '../openapi-types.gen.js';

export type { CreateGiftQuoteResponse, CreateGiftQuoteVars } from '../openapi-types.gen.js';

export const useCreateGiftQuote = createMutationHook<CreateGiftQuoteVars, CreateGiftQuoteResponse, unknown>({
  specName: 'useCreateGiftQuote',
  path: '/v1/gifts/quote',
  method: 'POST',
  resolveUrl: (vars: CreateGiftQuoteVars) => `/v1/gifts/quote`,
  buildBody: (vars: CreateGiftQuoteVars) => ({ recipientPlatform: vars.recipientPlatform, recipientHandle: vars.recipientHandle, recipientXIdStr: vars.recipientXIdStr, asset: vars.asset, senderWalletPubkey: vars.senderWalletPubkey, message: vars.message, anonymous: vars.anonymous }),
  parseResponse: (raw: unknown): CreateGiftQuoteResponse => raw as CreateGiftQuoteResponse,
  
  
  
});
